export default __webpack_public_path__ + "static/SRUS P450 - Product Specifications & Technical Data-000d464eddab94529ee99da0a6c46af3.pdf";